import MagstimTable from './MagstimTable';

import { CurrentLang } from 'common/utils/LocalisationUtils.js'

class MagstimTableClinic extends MagstimTable {


	initForSelect = (data, heightPx) => {
		// console.log(`MagstimTablePatient.initForSelect(${JSON.stringify(data)}, ${heightPx})`);
		this.initTable(this.configTableData(data, true), heightPx);
	}

	initForDisplay = (data, heightPx) => {
		this.initTable(this.configTableData(data, false), heightPx);
	}

	configTableData(data, select) {
		var retVal = {
			columns: [
				{ title: CurrentLang().organisation, property: 'Organisation', isSearchable:true},
				{ title: CurrentLang().clinic, property: 'Name', isSearchable:true },
				{ title: CurrentLang().clinic_users_per_clinic, property: 'SystemUserCount' },
				{ title: CurrentLang().patient_status, property: 'Status', alwaysSortedDirection: 1, formatter: this.formatStatus }
			],
			data: data
		};

		if(select === true){
			retVal.multiselect = true; 
			retVal.select =  {
                checked: { icon: 'fas fa-check-square', color: '#00AEEF' },
                unchecked: { icon: 'fas fa-square', color: '#C9DEFF' },
            }
		}

		return retVal;
	}

	resetFilters() {
		// console.log('MagstimTablePatient.resetFilters');
		super.resetFilters();
		this.addFilter('Status', 'Active');
	}

}

export default MagstimTableClinic;